/**
 * @file 検索
 */
'use strict';

/**
 * @classname ExemptionModal
 * @classdesc 検索
 */
export default class ExemptionModal {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-exemption')
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._denId = $e.attr('data-den-id');
		this._denName = $e.attr('data-den-name');
		this._$modal = $('#modal-exemption');
		$e.on('click', () => this.onClick());
		this._$modal[0].addEventListener('hidden.bs.modal', () => this.onCloseModal());
	};


	/**
	 * clickのコールバック
	 *
	 * @memberof ExemptionModal
	 * @return {undefined}
	 */
	onClick() {
		console.log(`${this.constructor.name}.onClick`);
		this._$modal.find('#den_id').val(this._denId);
		this._$modal.find('#den-name').text(this._denName);
		$('#den_exemption_reason').removeClass('ignore-validate');
	};


	/**
	 * modal closeのコールバック
	 *
	 * @memberof ExemptionModal
	 * @return {undefined}
	 */
	onCloseModal() {
		console.log(`${this.constructor.name}.onCloseModal`);
		this._$modal.find('#den_id').val('');
		this._$modal.find('#den-name').text('');
		$('#den_exemption_reason').addClass('ignore-validate').val('').change();
	};
}
